export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8918.d6fa1f05.jpg";